import { stock } from '@/data/stockImages';

// Doğrudan cevap + karşılaştırma (A/B). Hedef: restoran kroki sistemi, masa planı, masa takip programı.
// NOT: Tilki'de görsel (sürükle-bırak) kroki YOK; masalar bölgelere göre gruplu listede. Yazı bunu iddia etmez.
export default [
  {
    t: 'p',
    text: 'Restoran kroki sistemi, salondaki masa yerleşimini yazılımda bir plan (kroki) olarak gösteren ve her masanın durumunu bu plan üzerinde işaretleyen masa yönetimi ekranıdır. Garson ya da kasa, hangi masanın nerede olduğunu ve boş mu, dolu mu, hesap mı beklediğini tek bakışta görür. Aynı işi yapan bir başka yaklaşım da masaları salon, bahçe, teras gibi bölgelere göre gruplanmış bir liste hâlinde göstermektir.',
  },
  {
    t: 'p',
    text: 'Bu yazıda kroki sisteminin ne işe yaradığını, gruplu masa listesiyle farkını ve hangi işletmeye hangisinin daha uygun olduğunu anlatıyoruz.',
  },
  { t: 'h2', text: 'Restoran krokisi ne işe yarar?' },
  {
    t: 'img',
    img: stock('garson-siparis', 'Restoran salonunda tabletle sipariş alan garson'),
  },
  {
    t: 'list',
    items: [
      '**Yeni personelin masaları öğrenmesi:** Masa numaraları salonda nerede olduklarını söylemiyorsa, kroki bu bilgiyi ekrana taşır.',
      '**Bölge sorumluluğu:** Her garsonun hangi bölgeye baktığı plan üzerinde net görünür.',
      '**Durumun tek bakışta okunması:** Boş, dolu ve uzun süredir açık masalar renklerle ayrılır.',
      '**Rezervasyon ve oturma planı:** Kalabalık grupların nereye yerleştirileceği plan üzerinde düşünülebilir.',
    ],
  },
  { t: 'h2', text: 'Kroki mi, gruplu masa listesi mi?' },
  {
    t: 'p',
    text: 'İki yaklaşım da aynı soruya cevap verir: hangi masa ne durumda? Fark, bilginin nasıl sunulduğunda ve kurulum ile bakım yükündedir.',
  },
  {
    t: 'table',
    head: ['', 'Görsel kroki', 'Bölgelere göre gruplu liste'],
    rows: [
      ['Kurulum', 'Salonun planı yazılımda çizilir', 'Masa adı ve bölgesi girilir'],
      ['Düzen değişince', 'Kroki yeniden düzenlenir', 'Etkilenmez; gerekirse masa bölge değiştirir'],
      ['Telefonda kullanım', 'Plan küçülür, yakınlaştırmak gerekebilir', 'Liste telefon ekranında rahat okunur'],
      ['Yeni personel', 'Masanın yerini bulmak kolay', 'Masa adlarının anlamlı olması gerekir (ör. “Bahçe 3”)'],
    ],
  },
  { t: 'h2', text: 'Hangi işletmeye hangisi uygun?' },
  {
    t: 'p',
    text: '**Kroki**, masa düzeni sabit olan, geniş salonlu ve çok garsonla çalışan restoranlarda daha çok işe yarar; garsonların çoğunlukla tablet ya da kasa ekranından baktığı işletmelerde planın büyük görünmesi bir avantajdır.',
  },
  {
    t: 'p',
    text: '**Gruplu liste** ise siparişin garsonun kendi telefonundan alındığı, mevsime göre bahçe veya teras düzeni değişen kafe ve restoranlarda daha pratiktir. Masaları “Salon 1–12”, “Bahçe 1–8” gibi bölge adlarıyla numaralandırmak, kroki olmadan da yerin kolay bulunmasını sağlar.',
  },
  { t: 'h2', text: 'Masa düzenini planlarken dikkat edilecekler' },
  {
    t: 'list',
    items: [
      'Masa numaralarını salondaki gerçek sıraya göre verin; girişten başlayıp bir yönde ilerlemek, personelin ezberini kolaylaştırır.',
      'Bölgeleri personelin kullandığı adlarla tanımlayın: “alt kat”, “cam kenarı”, “bahçe” gibi.',
      'QR menüden sipariş alıyorsanız her masadaki kodun doğru masa numarasıyla eşleştiğini kontrol edin. Ayrıntısı [QR kod ile masadan sipariş](/blog/qr-kod-ile-masadan-siparis) yazısında.',
      'Kalabalık grup için birleştirilen masaların hesabının hangi masada tutulacağına baştan karar verin.',
    ],
  },
  { t: 'h2', text: 'Tilki Otomasyon’da masa takibi' },
  {
    t: 'p',
    text: 'Tilki’de masalar görsel kroki yerine bahçe, salon, teras gibi bölgelere göre gruplanmış bir ekranda gösterilir. Her masanın dolu ya da boş olduğu ve açık hesap tutarı görünür; ekranın üstünde toplam, dolu ve boş masa sayısı ile açık hesapların toplamı yer alır. Bu düzen garsonun telefonunda da okunaklı kalır. Kurulum adımları [rehberin sipariş bölümünde](/nasil-kullanilir#siparis).',
  },
  {
    t: 'guide',
    image: '11-masalar-ekrani',
    alt: 'Masalar ekranında bölgelere göre gruplanmış masalar, dolu ve boş masa sayıları',
    caption: 'Masalar ekranı: bölgelere göre gruplu masalar ve anlık durum.',
  },
  {
    t: 'cta',
    title: 'Masa düzeninizi birlikte kuralım',
    text: 'Ücretsiz demo talep edin; masalarınızı bölgelerine göre girip sipariş akışını gösterelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Restoran kroki sistemi için tablet gerekir mi?',
    a: 'Gerekmez, ama görsel krokiler büyük ekranda daha rahat kullanılır. Telefonla sipariş alınan işletmelerde bölgelere göre gruplanmış masa listesi genellikle daha pratiktir.',
  },
  {
    q: 'Masa numaraları nasıl verilmeli?',
    a: 'Salondaki gerçek sıraya göre ve bölge adıyla birlikte vermek en kolay yöntemdir: “Salon 1–12”, “Bahçe 1–8” gibi. Böylece yeni personel de masayı kroki olmadan bulabilir.',
  },
  {
    q: 'Masa düzeni değişince ne yapmak gerekir?',
    a: 'Görsel kroki kullanıyorsanız planı güncellemeniz gerekir. Gruplu listede ise çoğunlukla bir şey değişmez; yalnızca yeri değişen masanın bölgesini güncellemeniz yeterlidir.',
  },
];
